export default function slugify(str, options = {}) {
	if (!str || typeof str !== 'string') return str;

	if (options.removeDiacritics) {
		str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}
	return str.replace(/'+/g, '').replace(/[^a-z0-9]+/gi, '-').replace(/^-+|-+$/g, '').toLowerCase();
}